module.exports = __webpack_public_path__ + "static/media/photo124.09e04890.jpg";